module.exports = __webpack_public_path__ + "img/leonel_stete.e9a4a229.png";